/**
 * node-iterate79/fnc.js
 */
(function(module){
	var Promise = require('es6-promise').Promise;

	/**
	 * 関数の直列処理
	 */
	module.exports = function(aryFuncs){
		var mode = 'explicit';
		var defaultArg = undefined;
		if( arguments.length >= 2 ){
			mode = 'implicit';
			defaultArg = arguments[0];
			aryFuncs = arguments[arguments.length-1];
		}


		function iterator( aryFuncs ){
			aryFuncs = aryFuncs||[];
			var _this = this;

			_this.idx = 0;
			_this.idxs = []; // <- array keys
			for( var i in aryFuncs ){
				_this.idxs.push(i);
			}
			_this.idxsidxs = {}; // <- array keys keys
			for( var i in _this.idxs ){
				_this.idxsidxs[_this.idxs[i]] = i;
			}
			_this.funcs = aryFuncs;
			var isStarted = false;//2重起動防止

			this.start = function(arg){
				var _this = this;
				if(isStarted){return;}
				isStarted = true;
				new Promise(function(rlv){rlv();}).then(function(){ return new Promise(function(rlv, rjt){
					_this.next(arg);
				}); });
				return;
			}
			this.next = function(arg){
				var _this = this;
				arg = arg||{};
				if(_this.idxs.length <= _this.idx){return;}
				new Promise(function(rlv){rlv();}).then(function(){ return new Promise(function(rlv, rjt){
					(_this.funcs[_this.idxs[_this.idx++]])(_this, arg);
				}); });
				return;
			};
			this.goto = function(key, arg){
				var _this = this;
				_this.idx = _this.idxsidxs[key];
				arg = arg||{};
				if(_this.idxs.length <= _this.idx){return;}
				new Promise(function(rlv){rlv();}).then(function(){ return new Promise(function(rlv, rjt){
					(_this.funcs[_this.idxs[_this.idx++]])(_this, arg);
				}); });
				return;
			};
			this.break = function(){
				this.destroy();
				return;
			}
			this.destroy = function(){
				return;
			}
			return;
		}
		var rtn = new iterator(aryFuncs);
		if( mode == 'implicit' ){
			rtn.start(defaultArg);
			return rtn;
		}
		return rtn;
	}


})(module);
